export const formatPhoneNumberDivision = (countryCode, phoneNumber) => {
    // Check if the phone number is valid
    // console.log(countryCode, phoneNumber);
    if (phoneNumber === null || phoneNumber === undefined) {
        return { countryCode: null, phone: null };
    }
    if (!phoneNumber) {
        return { countryCode: null, phone: null };
    }

    // console.log(countryCode, phoneNumber);


    phoneNumber = `${phoneNumber.startsWith("+") ? phoneNumber : `+${phoneNumber}`}`;

    // Remove the country code from the phone number if it starts with it
    const phoneWithoutCode = phoneNumber.startsWith(countryCode.toString())
        ? phoneNumber.slice(countryCode.toString().length)
        : phoneNumber;

    return {
        countryCode: countryCode,
        phone: phoneWithoutCode
    };

}

export const allFeatures = [
    "Employees", 
    "Notifications", 
    "Dashboard",
    "Advances", 
    "Salaries", 
    "Attendance", 
    "Office Locations", 
    "Employee Requirements",
    "shift Requests",
    "Time Off", 
    "General Settings", 
    "Work Shifts",
    "Employment Status", 
    "Work Type", 
    "Tags", 
    "Holidays", 
    "Time Off Types", 
    "Positions", 
    "Deductions", 
    "Roles", 
    "Admins",
    "Logs", 
    "Events", 
];

export const featureKeyMap = {
    "Notifications": "notifications",
    "Dashboard": "dashboard",
    "Employees": "employees",
    "Advances": "advances",
    "Salaries": "salaries",
    "Attendance": "attendance",
    "Office Locations": "officeLocations",
    "Employee Requirements": "employeeRequirements",
    "Shift Requests": "shiftRequests",
    "Time Off": "timeOff",
    "General Settings": "generalSettings",
    "Work Shifts": "workShifts",
    "Employment Status": "employmentStatus",
    "Work Type": "workType",
    "Tags": "tags",
    "Holidays": "holidays",
    "Time Off Types": "timeOffTypes",
    "Positions": "positions",
    "Deductions": "deductions",
    "Roles": "roles",
    "Admins": "admins",
    "Logs": "logs",
    "Events": "events"
};

export const featureDescriptions = {
    employeeManagement: "Employee Management",
    attendanceManagement: "Attendance Management",
    shiftRequestMangement: "Shift Request Management",
    timeOffManagement: "Time Off Management",
    SalaryManagement: "Salary Management",
    advancesManagement: "Advances Management",
    companySetup: "Company Setup",
    workForceSetup: "Workforce Setup",
    policiesCompliance: "Policies & Compliance",
    systemManagement: "System Management",
    quickBookIntgrate: "QuickBook Integration"
};


export const formatPrice = (amount) => {
    // Ensure amount is a valid number or set it to 0
    let validAmount = parseFloat(amount);

    // Check if the parsed value is a number, if not, set it to 0
    if (isNaN(validAmount)) {
        validAmount = 0;
    }

    // Convert to a string with two decimal places
    let formattedAmount = validAmount
        .toFixed(2) // ensures two decimal places
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ","); // adds thousands separator

    // Remove ".00" if it's a whole number
    if (formattedAmount.endsWith(".00")) {
        formattedAmount = formattedAmount.slice(0, -3); // Remove the .00
    }


    return `$${formattedAmount}`;
};


export const featuresAndPackage = {
    "employeeManagement": {
        key: ["employee"],
        actions: ["add", "edit", "view", "delete", "import", "export"]
    },
    "attendanceManagement": {
        key: ["attendance"],
        actions: ["add", "edit", "view"]
    },
    "shiftRequestMangement": {
        key: ["shiftRequests"],
        actions: ["add", "view", "accept", "reject"]
    },
    "timeOffManagement": {
        key: ["timeOff"],
        actions: ["add", "edit", "view", "accept", "reject"]
    },
    "SalaryManagement": {
        key: ["salaries"],
        actions: ["view"]
    },
    "advancesManagement": {
        key: ["advances"],
        actions: ["add", "edit", "view", "accept", "reject"]
    },
    "companySetup": {
        key: ["officeLocations", "generalSettings", "employeeRequirements"],
        actions: ["add", "edit", "view", "delete"]
    },
    "workForceSetup": {
        key: ["positions", "tags"],
        actions: ["add", "edit", "view", "delete"]
    },
    "policiesCompliance": {
        key: ["workShifts", "employmentStatus", "workType", "holidays", "timeOffTypes", "deductions"],
        actions: ["add", "edit", "view", "delete"]
    },
    "systemManagement": {
        key: ["roles", "admins", "logs", "events"],
        actions: ["add", "edit", "view", "delete"]
    },
    "quickBookIntgrate": {
        key: ["quickBook"],
        actions: ["view"]
    }
}

export const getEnabledFeatures = (permission) => {
    return Object.entries(featuresAndPackage)
        .filter(([_, feature]) =>
            feature.key.every(k => permission.hasOwnProperty(k))
        )
        .map(([featureName]) => featureName);
}
